export const localErrors = {
  METEOCODE_ALREADY_EXIST: 'Этот метеокод уже существует!',
  UNIT_ALREADY_EXIST: 'Такая единица измерения уже существует!',
  DATASOURCE_TYPE_KOD_NOT_UNIQUE: 'Невозможно добавить источник. Код указанного типа источника используется у другого существующего источника',
  ALREADY_EXIST: 'Этот объект уже существует!',
  CRON_EXPRESSION_PARSE_ERROR: 'Невалидное Cron Expression',
  VOC_ENTITY_PARAM_CODE_ALREADY_EXIST: 'Параметр с таким кодом уже существует',
  VOC_ENTITY_PARAM_VALUE_CODE_ALREADY_EXIST: 'Значение с таким кодом уже существует',
  SEBA_MAPPING_SETTING_ALREADY_EXISTS: 'Настройка контроллера SEBA с такими типом источника и номером канала уже существует!',
};
